// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './datasource';
import 'myWorld/layers/tileIdLayer';
import 'myWorld/layers/blankLayer';

/**
 *  @class Datasource to provide layers that don't require an actual datasource (i.e are client side calculated)
 *  @name BuiltInDatasource
 */
myw.BuiltInDatasource = myw.Datasource.extend('BuiltInDatasource', {
    statics: {
        layerDefFields: [
            { name: 'mapType', type: 'enumerator', enumerator: ['Blank', 'Tile IDs'] }
        ],
        specFields: []
    },

    options: {
        defs: {
            Blank: 'myw.BlankLayer',
            'Tile IDs': 'myw.TileIdentificationLayer'
        }
    },

    /**
     * Instantiates a leaflet layer from a layer definition
     * @param  {layerDefinition} layerDef
     * @return {ILayer}
     */
    createLayer(layerDef) {
        let layer, expr, Constructor;

        try {
            expr = this.options.defs[layerDef.mapType];
            Constructor = myw.Util.evalAccessors(expr);
            layer = new Constructor(layerDef.options);
        } catch (e) {
            if (typeof Constructor !== 'function') {
                console.log(`Could not evaluate '${expr}' to a class`);
            }
            console.log(`Error instantiating layer '${layerDef.name}'. Exception: ${e}`);
        }

        return layer;
    }
});

myw.datasourceTypes['built_in'] = myw.BuiltInDatasource;

export default myw.BuiltInDatasource;
